import http from '../api/http';

export default {

    async displaySettings() {
        let url = `/v1/venue/cashup/settings`
        return await http.get(url)
    },

    async saveSetting(payloads) {
        let url = `/v1/venue/cashup/settings`

        return http.post(url, payloads)
    },

    async getCashUpRecord(payloads) {
        let url = `/v1/venue/cashup/record?reportDate=${payloads.reportDate}`
        return await http.get(url)
    },

    async saveCashupRecord(payloads, isSend = false) {
        let url = `/v1/venue/cashup/record?isSend=${isSend}`
        return await http.post(url, payloads)
    },

    async saveCashup (payloads, isSend = false) {
        let venueId = window.sessionStorage.getItem("subVenueId")
        let url = `/v1/venue/cashup/${payloads.venueType}/${venueId}/record?sendEmail=${isSend}`
        return await http.post(url, payloads)
    },

    async getCashup (payloads) {
        let venueId = window.sessionStorage.getItem("subVenueId")
        let url = `/v1/venue/cashup/record/${venueId}?reportDate=${payloads.reportDate}&recordType=${payloads.type}&venueType=${payloads.venueType}`
        return await http.get(url)
    },


}



// WEBPACK FOOTER //
// ./src/api/cashup.js